module.exports = __webpack_public_path__ + "static/media/logo.938bcd91.png";